module.exports = __webpack_public_path__ + "static/img/st-3.3bb7337.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/image/st-3.jpg
 ** module id = 587
 ** module chunks = 2
 **/